module.exports = __webpack_public_path__ + "img/silver_streak.4e90adf2.png";